import { Create, Delete, SettingsBackupRestore } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import ConfirmAlert from "../../utils/ConfirmAlert";
import CustomMuiSwitch from "../../utils/customMuiSwicth/CustomMuiSwitch";
import TopHeading from "../../utils/TopHeading/TopHeading";
import CustomTable from "../../views/CustomTable/CustomTable";
import AnimatedPage from "../animatedPage/AnimatedPage";
import Hoc from "../HOC/Hoc";
import ConfLanguage from "./ConfLanguage";
import { deleteLanguage } from "./language.api";

const Language = (props) => {
  const {
    data,
    loading,
    page,
    setPage,
    pageCount,
    handleOpenModal,
    handleCloseModal,
    openModal,
    setSuccess,
    setError,
    openEditModal,
    handleOpenEditModal,
    handleCloseEditModal,
    setAlert,
    alert,
    closeAlert,
    showPagination,
    setShowPagination,
    hidePagination,
  } = props;
  const [languages, setLanguages] = useState([]);
  const [editId, setEditId] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  useEffect(() => {
    if (data) {
      setLanguages(data);
    }
    return () => {
      setLanguages(data);
    };
  }, [data]);

  useEffect(() => {
    if (data && data.length > 0) {
      const item = data.find((item) => item.id === editId);
      if (item) {
        setSelectedItem(item);
      }
    }

    return () => {
      setSelectedItem({});
    };
  }, [editId, data]);

  const handleDelete = (id) => {
    deleteLanguage(id)
      .then((res) => {
        if (res?.status === 200) {
          setSuccess();
        } else {
          setError("Something went wrong");
        }
      })
      .catch((err) => {
        setError("Something went wrong");
      });
  };

  const rows = [];
  const labels = ["Name", "Status", "Actions"];
  languages &&
    languages.length > 0 &&
    languages.map((item) =>
      rows.push([
        item.language,
        <CustomMuiSwitch checked={item.isActive} />,
        <Stack direction={"row"}>
          <IconButton
            onClick={() => {
              setEditId(item.id);
              handleOpenEditModal();
            }}
          >
            <Create />
          </IconButton>
          <ConfirmAlert msg={'Are you sure you want to delete?'} onClickEvent={() => handleDelete(item.id)}>
            <IconButton>
              <Delete />
            </IconButton>
          </ConfirmAlert>
        </Stack>,
      ])
    );
  return (
    <>
    <AnimatedPage>

      <TopHeading openModal={handleOpenModal} heading="Language" />
      <ConfLanguage
        open={openModal}
        loading={loading}
        type="ADD"
        hadnleCloseModal={handleCloseModal}
        setSuccess={setSuccess}
        setError={setError}
        setAlert={setAlert}
      />
      <ConfLanguage
        open={openEditModal}
        loading={loading}
        type="EDIT"
        hadnleCloseModal={handleCloseEditModal}
        setSuccess={setSuccess}
        setError={setError}
        setAlert={setAlert}
        editId={editId}
        selectedItem={selectedItem}
      />
      <CustomTable labels={labels} data={rows} pageLoading={loading} />
    </AnimatedPage>
    </>
  );
};

export const EnhancedLanguage = Hoc(Language, { name: "language" });
